/**
 * Created by dpardell on 20/06/2025.
 */
angular
    .module('annexaApp')
    .component('annexaObjectConfigList', {
        templateUrl: './components/admin/annexa-config-object-list/annexa-object-config-list.html',
        controller: ['HeaderService', '$rootScope', '$state', 'Language', 'TableFilterFactory', '$filter', 'globalModals', 'CommonAdminModals', 'AnnexaFormlyFactory', '$http', 'AnnexaModalFactory', 'RestService', 'CommonService', 'dialogs', 'SecFactory', 'AdminFactory', 'DialogsFactory', '$scope', function (HeaderService, $rootScope, $state, Language, TableFilterFactory, $filter, globalModals, CommonAdminModals, AnnexaFormlyFactory, $http, AnnexaModalFactory, RestService, CommonService, dialogs, SecFactory, AdminFactory, DialogsFactory, $scope) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            vm.getLiterals = function(literal){
            	if(vm.data && vm.data.listLiterals && vm.data.listLiterals[literal]){
            		return $filter('translate')(vm.data.listLiterals[literal]);
            	}else{
            		return literal;
            	}
            }
        }],
        bindings: {
            data: '='
        }
    });